import { Reducer } from 'react';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import { getLandingAsync } from '../actions';
import { LandingsActions } from '../types';
import getlandingWithDefaults from '@anm/helpers/video-landings/getLandingWithDefaults';
import { initialLandingsState } from './index';

const getLandingReducer: Reducer<typeof initialLandingsState, LandingsActions> = (
  state = initialLandingsState,
  action
) => {
  switch (action.type) {
    case getType(getLandingAsync.request): {
      const { params } = action.payload;

      return {
        ...state,
        getLanding: {
          params,
          isError: false,
          isPending: true
        }
      };
    }

    case getType(getLandingAsync.success): {
      const landing = action.payload;

      return {
        ...state,
        data: {
          currentLanding: getlandingWithDefaults(landing, state.getLanding.params?.videoSizes),
          savedLanding: getlandingWithDefaults(landing, state.getLanding.params?.videoSizes)
        },
        getLanding: {
          error: null,
          isError: false,
          isPending: false
        }
      };
    }

    case getType(getLandingAsync.failure): {
      const error = action.payload;

      return {
        ...state,
        getLanding: {
          error,
          isError: true,
          isPending: false
        }
      };
    }

    default:
      return state;
  }
};

export default getLandingReducer;
